<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->

    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs" v-model="tabIndex">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-1">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.referenceno }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Issue Date" label-size="sm" :disabled="true">
                      <b-input-group>
                        <b-form-input :value="item.issued_at
                          ? this.$helpers.datetimefield(item.issued_at)
                          : null
                          " :disabled="readonly" placeholder="(auto)"></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Reference No" label-size="sm" class="text-danger">
                      <b-input-group>
                        <b-form-input v-model="item.referenceno" :debounce="options.debounce" placeholder="(auto)"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="true"
                            @click="item.referenceno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="false" label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.agent" placeholder="Agent"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="false" @click="item.agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Invoice No" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.invoiceno" :debounce="options.debounce" placeholder="Invoice No"
                          :disabled="user.permissions.includes('carhire.admin') ? false : true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary"
                            :disabled="user.permissions.includes('carhire.admin') ? false : true"
                            @click="item.invoiceno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <!-- <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm"> -->
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Supplier B/L')" :class="$helpers
                      .requiredlabel(requirement, 'Supplier B/L')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-size="sm">
                      <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.blac" :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>


                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Cost Invoice No" label-for="blinvoiceno" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:90px; top:-13px">
                        <i id="blinvoiceno" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="blinvoiceno" triggers="hover" placement="top">BL PO
                      </b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.blinvoiceno" placeholder="Cost Invoice No" size="sm"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                            @click="item.blinvoiceno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group id="cost" label="Cost GBP" label-for="cost" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:60px; top:-12px">
                        <i class="fa fa-info-circle text-danger"></i>
                      </b-input-group>
                      <b-tooltip target="cost" triggers="hover" placement="bottom">Be sure
                        to costs for the ledger</b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.cost" placeholder="BL Total" size="sm" :state="false"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly" variant="outline-secondary" @click="item.cost = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Sale GBP" label-for="sale" label-cols="12">
                      <b-input-group class="treeselect_all" style="left:60px; top:-13px">
                        <i id="sale" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="sale" triggers="hover" placement="top">Use Ghold to set this value
                      </b-tooltip>
                      <b-input-group>
                        <b-form-input type="text" v-model="item.sale" placeholder="SL Total" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="true" variant="outline-secondary" @click="item.sale = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <!-- <b-form-group label-cols="12" label="Client SL A/C" label-size="sm"> -->
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Client SL A/C')" :class="$helpers
                      .requiredlabel(requirement, 'Client SL A/C')
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.yourref" :debounce="options.debounce" placeholder="Your Ref/PO"
                          :disabled="readonly" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.yourref = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Event" label-size="sm">
                      <treeselect placeholder="Select event..." v-model="item.eventcode" :clearable="true" :async="true"
                        :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..."
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Status" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:40px; top:-13px">
                        <i id="id_status" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="id_status" triggers="hover" placement="top">Change status to 'Ready' to show in
                        Ghold
                      </b-tooltip>
                      <treeselect placeholder="Select status..." v-model="item.status" :clearable="true"
                        :multiple="false" :options="status_options" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                </b-row>

                <b-row align-v="end" class="nopadding my-3 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    First Segment
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Start City" label-size="sm">
                      <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                        v-model="item.startcity" :disabled="readonly" :clearable="true" :async="true"
                        :load-options="treeselect_loadAirport" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" :title="item.startcity +
                          ' ( ' +
                          item.startcityname +
                          ' )'
                          " search-nested>
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                          {{ node.raw.id && item.startcityname ? '( ' + item.startcityname
                            +
                            ')' : "" }}
                        </div>
                      </treeselect>
                    </b-form-group>

                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Start DateTime" label-size="sm">
                      <b-input-group>
                        <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="start_at"
                          :disabled="readonly" :opens="'right'" :single-date-picker="'single'" :locale-data="{
                            direction: 'ltr',
                            format: 'dd/mm/yy HH:MM',
                            daysOfWeek: [
                              'Sun',
                              'Mon',
                              'Tue',
                              'Wed',
                              'Thu',
                              'Fri',
                              'Sat',
                            ],
                            monthNames: [
                              'January',
                              'February',
                              'March',
                              'April',
                              'May',
                              'June',
                              'July',
                              'August',
                              'September',
                              'October',
                              'November',
                              'December',
                            ],
                            firstDay: 1,
                          }" :showDropdowns="true" :ranges="false" :linkedCalendars="true" :timePicker="true"
                          :timePicker24Hour="true" :time-picker-increment="1">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="start_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="End DateTime" label-size="sm">
                      <b-input-group>
                        <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="end_at"
                          :disabled="readonly" :opens="'right'" :single-date-picker="'single'" :locale-data="{
                            direction: 'ltr',
                            format: 'dd/mm/yy HH:MM',
                            daysOfWeek: [
                              'Sun',
                              'Mon',
                              'Tue',
                              'Wed',
                              'Thu',
                              'Fri',
                              'Sat',
                            ],
                            monthNames: [
                              'January',
                              'February',
                              'March',
                              'April',
                              'May',
                              'June',
                              'July',
                              'August',
                              'September',
                              'October',
                              'November',
                              'December',
                            ],
                            firstDay: 1,
                          }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                          :timePicker24Hour="true" :time-picker-increment="1">
                        </daterangepicker>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="end_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="End City" label-size="sm">
                      <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                        v-model="item.endcity" :disabled="readonly" :clearable="true" :async="true"
                        :load-options="treeselect_loadAirport" :show-count="true" :flatten-search-results="true"
                        :disable-branch-nodes="true" :matchKeys="['id']" :title="item.endcity +
                          ' ( ' +
                          item.endcityname +
                          ' )'
                          " search-nested>
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                          {{ node.raw.id && item.endcityname ? '( ' + item.endcityname + ' ) '
                            : "" }}
                        </div>
                      </treeselect>

                    </b-form-group>

                  </b-col>

                  <b-col cols="12" sm="6" md="6" xl="6">
                    <b-form-group :disabled="readonly" label-cols="12" label="Start Location" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.startlocation" :debounce="options.debounce"
                          placeholder="Start Location" trim :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.startlocation = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="6" xl="6">
                    <b-form-group :disabled="readonly" label-cols="12" label="End Location" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.endlocation" :debounce="options.debounce" placeholder="End Location"
                          trim :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.endlocation = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" id="cabinco2" label-cols="12" label="Cabin CO2" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:65px; top:-15px">
                        <i class="fa fa-leaf text-primary"></i>
                      </b-input-group>
                      <b-tooltip target="cabinco2" triggers="hover" placement="bottom">Required
                        field for
                        Carbon</b-tooltip>
                      <treeselect placeholder="Cabin CO2" v-model="item.cabin" :clearable="false" :multiple="false"
                        :options="options_cabin" :matchKeys="['id']" :disabled="readonly">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>

                  </b-col>

                  <b-col id="equipmentco2" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Equipment (SIPP) CO2" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:120px; top:-15px">
                        <i class="fa fa-leaf text-primary"></i>
                      </b-input-group>
                      <treeselect :disabled="readonly" placeholder="Equipment (SIPP)" v-model="item.equipment"
                        :clearable="false" :multiple="false" :options="options_equipment" :matchKeys="['id']">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                    <b-tooltip target="equipmentco2" triggers="hover" placement="bottom">Required
                      field for
                      Carbon</b-tooltip>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="ConfirmNo" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.reference" :debounce="options.debounce" placeholder="ConfirmNo" trim
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.reference = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Quoted Rate + Currency" label-for="quoted" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.quoted" placeholder="Enter quoted rate" size="sm"
                          lazy-formatter :formatter="nocomma" :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.quoted = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>



                </b-row>

                <b-row align-v="end" class="nopadding my-3 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    First Traveller
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Traveller/Driver" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:85px; top:-13px">
                        <i id="traveller" class="fa fa-info-circle text-black"></i>
                      </b-input-group>
                      <b-tooltip target="traveller" triggers="hover" placement="top">
                        Enter SURNAME/FIRSTNAME or enter Surname and First Name fields to set this automatically.
                      </b-tooltip>
                      <b-input-group>
                        <b-form-input v-model="item.passenger" :debounce="options.debounce"
                          placeholder="Passenger/Driver" trim :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.passenger = reversenamecap(item.passenger, true)"
                            title="Reverse Name Capitalise">
                            <i class="fa fa-exchange text-primary"></i>
                          </b-button>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.passenger = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Surname" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.surname" :debounce="options.debounce" placeholder="Surname"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.surname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="First Name" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.firstname" :debounce="options.debounce" placeholder="First Name"
                          :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.firstname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly" label-cols="12" label="Title" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.title" :debounce="options.debounce" placeholder="Title"
                          :disabled="readonly" list="list-title"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.title = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    MI Fields
                  </b-col>
                </b-row>

                <!-- {{ mifields }} -->
                <b-row v-if="mifields.length > 0">
                  <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields" :key="index">
                    <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)" :class="$helpers
                      .requiredlabel(requirement, mifield.label)
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-cols="12" label-size="sm">
                      <b-input-group>
                        <b-form-input v-if="mifield.type == 'input'" type="text" :disabled="mifield.active == '0'"
                          size="sm" trim v-model="mifield.value" :placeholder="mifield.label"></b-form-input>
                        <b-input-group-append v-if="mifield.type == 'input'" @click="mifield.value = ''">
                          <b-button size="sm" variant="outline-secondary">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true"
                        :flatten-search-results="true" :clearable="false" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :options="mifield.options" v-model="mifield.value">
                      </treeselect>

                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="mifields.length == 0">
                  <b-col>
                    There are no fields to display
                  </b-col>
                </b-row>

                  <b-row class="mt-4"><b-col><span class="text-danger small">* Required</span></b-col></b-row>
              </p>
            </b-tab>

            <b-tab>
              <template #title>
                <i class="fa fa-ticket text-primary mr-1"></i>
                Voucher</template>
              <p class="py-3 px-0">
              <div class="etr componentview">
                <b-card-header>
                  <b-row align-v="top" no-gutters>
                    <b-col cols="8">
                      <b-button v-print="'#paper'" squared size="sm" class="mr-4 inline" title="Print" :disabled="busy">
                        <i class="fa fa-print pr-3"></i>Print
                      </b-button>
                      <div class="inline-block">
                        <i class="fa fa-car fa-2x mr-1 text-primary"></i>

                        <span class="h4 ml-1 text-primary">Confirmation No: {{ item.reference }}</span>
                      </div>
                    </b-col>
                    <b-col class="text-right">
                      <b-button-group>
                        <b-button class="mr-1" squared size="sm" variant="primary" @click="voucher_download()">
                          <i :class="busy
                            ? 'fa fa-spinner fa-spin pr-3'
                            : 'fa fa-file-pdf-o pr-3'
                            "></i>Download
                        </b-button>
                      </b-button-group>
                    </b-col>
                  </b-row>
                </b-card-header>
                <b-card-body>
                  <div id="paper" class="mb-3 p-4 background-white text-secondary">
                    <div class="border-black p-4">
                      <b-row>
                        <b-col cols="2">
                          <!-- <img
                      class="logo mt-4 ml-4 h-50px"
                      src="/img/brand/ABTA.jpg"
                      alt="ABTA"
                  /> -->
                        </b-col>
                        <b-col class="text-center"><img class="logo mb-3"
                            src="/img/brand/RGB Travel Places Primary Logo.bmp" alt="Travel Places" height="70"
                            width="190" /><br />
                          <span>
                            Travel Places, in association with American Express Global
                            Business Travel
                          </span>
                        </b-col>
                        <b-col cols="2">
                          <img class="logo h-30px mt-4" src="/img/brand/IATA.jpg" alt="IATA" />
                        </b-col>
                      </b-row>
                      <b-row class="text-center strong">
                        <b-col>Podium House 61 Chapel Road, Worthing, West Sussex, BN11 1HR
                          T: +44 (0) 1903 832888 F: +44 (0) 1903 231179</b-col>
                      </b-row>
                    </div>
                    <div class="border-black border-top-none p-4">
                      <div class="text-center large strong underline">
                        Car Rental Voucher
                      </div>
                      <b-row>
                        <b-col> Car Rental Company:
                          <span v-if="item.blac" class="strong">{{ item.blacname }}</span>
                          <!-- <span v-if="item.blphone">
                  Local Phone Number:
                  <span class="strong">{{ item.blphone }}</span>
                  <br />
                </span> -->
                          <br />
                          Travel Places Agent Reference:
                          <span v-if="item.agent" class="strong">{{ item.agent }}</span><br />
                          <span v-if="item.agent">
                            Email: <span class="strong">{{ item.agentemail }}</span>
                          </span>
                          <br /></b-col>
                        <b-col class="text-right">
                          <img class="logo h-50px" :src="item.blaclogo" :alt="item.blacname" :title="item.blacname" />
                        </b-col>
                      </b-row>


                    </div>
                    <div class="border-black border-top-none p-4">
                      <span class="strong"> BOOKING DETAILS</span><br />
                      Reservation number:
                      <span class="strong">{{ item.reference }} </span><br />
                      Driver Name (s): <span class="strong">{{ item.passenger }}</span><br />
                      <span v-if="item.equipment">Car Group:
                        <span class="strong">{{ item.equipment }} {{ item.equipmentname }}</span><br /></span>
                      <br />

                      <span> Pick Up: </span>
                      <span class="strong" v-if="item.start_at">{{ $moment.unix(this.item.start_at *
                        0.001).utc(false).format("DD/MM/YY HH:mm") }}</span>
                      <span class="strong" v-if="item.startlocation">, {{ item.startlocation }}</span>
                      <br />
                      <span> Drop Off: </span>
                      <span class="strong" v-if="item.end_at">{{ $moment.unix(this.item.end_at *
                        0.001).utc(false).format("DD/MM/YY HH:mm") }}</span>
                      <span class="strong" v-if="item.endlocation">, {{ item.endlocation }}</span>
                      <br />

                      <div>
                        <br />
                        <span class="strong">ADDITIONAL DETAILS </span>
                        <br />
                        <b-form-textarea id="data" v-model="item.data" placeholder="Type here" rows="6"
                          class="smalltextarea"></b-form-textarea>
                        <!-- {{ item.notes }} -->
                      </div>
                    </div>
                    <div class="border-black border-top-none p-4">
                      <span class="strong">Company to be invoiced:</span> <br />
                      Account: <span class="strong">{{ item.slac }}</span> <br />
                      Company: <span class="strong">{{ item.slacname }}</span><br />
                      Account: <span class="strong">Paid By Travel Places</span><br />
                      <!-- [ X ] Invoiced To Account [
              &nbsp;&nbsp;&nbsp; ] Direct By Client [ &nbsp;&nbsp;&nbsp; ]<br /> -->
                      <!-- (paymethod: {{slac_item.paymethod}}, invoicetype: {{slac_item.invoicetype}},       accounttype: {{slac_item.accounttype}}, statementtype: {{slac_item.statementtype}}) -->
                    </div>
                    <div>
                      <b-row>
                        <b-col cols="12" sm="6">
                          <b-form-group label="Email To" label-for="email" label-cols="12">
                            <b-input-group>
                              <b-form-input type="text" v-model="email" placeholder="Email" size="sm"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="email = ''">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                              <b-button squared size="sm" @click="voucher_email()" variant="primary">
                                <i class="fa fa-paper-plane pr-3"></i>Send
                              </b-button>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-card-body>
              </div>

              </p>
            </b-tab>

            <b-tab>
              <template #title>
                <i class="fa fa-comments-o text-primary mr-1"></i>
                Notes</template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Notes" label-for="notes" label-cols="12">
                      <b-form-textarea id="data" v-model="item.notes" placeholder="Notes" rows="12"
                        class="smalltextarea"></b-form-textarea>
                    </b-form-group> </b-col></b-row>
                <b-row class="mt-1">
                  <b-col>
                    <b-button squared size="sm" variant="outline-primary" class="mr-1" @click="timestamp">
                      <i class="fa fa-comment-o"></i>
                      Add Notes
                    </b-button>
                  </b-col>
                </b-row>
              </p>
            </b-tab>

            <!-- <b-tab v-if="this.user.permissions.includes('systems.development')" @click="ihold_load">
              <template #title>
                <i class="fa fa-stack-exchange text-primary mr-1"></i>
                Invoicing - 'systems.development'</template>

              <div class="px-3 mt-2 mb-2">
                <e-table classdivtable="availtable datatable w-100pct" refid="ihold" :busy="ihold.busy"
                  :icon="ihold.icon" :selectmode="'none'" :showtoolbar="false" :showfab="false" :showsheets="false"
                  :showrowcount="false" :showautoadd="false" :showpages="false" :offset="ihold.offset"
                  :limit="ihold.limit" :page="ihold.page" :tools="ihold.tools" :badges="ihold.badges"
                  :fields="ihold.fields" :items="ihold.items" @click="ihold_click" @select="ihold_select"
                  @load="ihold_load">
                </e-table>
              </div>


            </b-tab> -->
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="ID" label-for="id" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

              </p>
            </b-tab></b-tabs>

        </b-card-body>

        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit"
                v-if="user.permissions.includes('carhire.save') && tabIndex < 2">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

import * as fs from "file-saver";

export default {
  name: "CarHireEdit",
  async mounted() {

    try {
      const response = await this.$apollo.query({
        query: gql`
            query setup_carsipps {
              setup_carsipps {
                id
                label
              }
            }
          `,
      });
      this.options_equipment = response.data.setup_carsipps;
    } catch (error) {
      console.log(error);
    }
    this.email = this.user.email

     if (!this.requirement.blac) {
      this.requirement.blac = "Supplier B/L"
    } 
    if (!this.requirement.slac) {
      this.requirement.slac = "Client SL A/C"
    }


  },
  data() {
    return {
      busy: false,
      tabIndex: 0,
      readonly: false,
      start_at: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      end_at: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      options_cabin: [
        { id: "ECONOMY", label: "ECONOMY" },
        { id: "PREMIUM", label: "PREMIUM" },
        { id: "BUSINESS", label: "BUSINESS" },
        { id: "FIRST", label: "FIRST" }
      ],
      options_equipment: [],
      status_options: [
        { id: "ready", label: "Ready" },
        { id: "unsubmitted", label: "Unsubmitted" },
        { id: "pending", label: "Pending" },
        { id: "cancelled", label: "Cancelled" },
      ],
      email: null,
      item: {
        issued_at: null,
        referenceno: null,
        agent: null,
        invoiceno: null,
        blac: null,
        blinvoiceno: null,
        cost: null,
        sale: null,
        quoted: null,
        slac: null,
        yourref: null,
        eventcode: null,
        // booker: null,
        startcity: null,
        start_at: null,
        end_at: null,
        endcity: null,
        startlocation: null,
        endlocation: null,
        cabin: "BUSINESS",
        equipment: "CDMR",
        reference: null,
        pax: null,
        passenger: null,
        surname: null,
        firstname: null,
        title: null,
        description: null,
        notes: null,
        status: "unsubmitted"
      },
      options: {
        title: "Car Hire",
        icon: "fa fa-car text-dark",
        debounce: 500,
      },
      ihold: {
        title: "Car Hire",
        icon: "fa fa-car text-dark",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        filter: false,
        tools: "go,filter",
        fields: [
          {
            key: "litem",
            label: "Inventory Lines",
            type: "iginvoice",
            class: "text-left w-90pct",
            clearable: "true",
          },
        ],
        badges: [],
        items: [],
        selected: [],
      }
    };
  },
  watch: {
    "item.surname": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.passenger = newVal.toUpperCase()
          if (this.item.firstname) {
            this.item.passenger += "/" + this.item.firstname
          }
        }
      },
    },
    "item.firstname": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.passenger = this.item.surname.toUpperCase() + "/" + newVal.toUpperCase()
        }
      },
    },
    "item.slac": {
      async handler(newVal, oldVal) {
        if (typeof newVal === "undefined") {
          this.item.slac = ""
        }
        await this.load_mifields();
      }
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carhire($id: String) {
              carhire(id: $id) {
                    id
                    type
                    issued_at
                    referenceno
                    invoicetype                                       
                    yourref
                    start_at
                    blac  
                    reference
                    cost                    
                    markup
                    sale  
                    quoted                                     
                    slac
                    eventcode             
                    agent
                    status
                    invoiceno    
                    blinvoiceno
                    cost
                    sale
                    # booker                    
                    startcity
                    end_at
                    endcity
                    startlocation
                    endlocation
                    cabin
                    equipment
                    reference
                    pax
                    passenger
                    surname
                    firstname
                    title
                    description
                    data
                    tags
                    notes
                    equipmentname
                    blacname
                    blaclogo
                    slacname
                    agentemail
                    created_at
                    created_by
                    updated_at
                    updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.carhire.length > 0) {
          this.item = response.data.carhire[0];

          if (this.item.start_at) {
            let v = this.$moment.unix(this.item.start_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
            this.start_at = { startDate: v, endDate: v }
          }
          if (this.item.end_at) {
            let v = this.$moment.unix(this.item.end_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
            this.end_at = { startDate: v, endDate: v }
          }
        }

      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },


    async voucher_email() {

      let variables = {
        selected: [{ id: this.idselected }],
        emailto: this.email,
        documentformat: "CAR_2",

      };
      console.log("variables", variables);
      let sent = false;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query carhire_voucher(
              $selected: [InventoryLine_input]  
              $documentformat: String
              $emailto: String
              ) {
              carhire_voucher( 
                selected: $selected
                documentformat: $documentformat
                emailto: $emailto
                ) 
            }
          `,
          variables,
        });

        sent = response.data.carhire_voucher.length > 0 ? true : false;

      } catch (error) {
        console.log(error);
      }
      if (sent) {
        this.message =
          "<span class='text-primary'>Car Hire vouchers are being emailed</span>";
        // "<span class='text-primary'>Car Hire vouchers will be emailed to you by SL A/C</span>";
      } else {
        this.message = "<span class='text-danger'>Email not sent!</span>";
      }

      this.busy = false;
    },

    async voucher_download() {

      let variables = {
        selected: [{ id: this.idselected }],
        documentformat: "CAR_2",

      };
      console.log("variables", variables);
      let sent = false;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query carhire_voucher(
              $selected: [InventoryLine_input]  
              $documentformat: String
              ) {
              carhire_voucher( 
                selected: $selected
                documentformat: $documentformat
                ) 
            }
          `,
          variables,
        });

        if (response.data.carhire_voucher.length > 0) {
          let byteCharacters = atob(response.data.carhire_voucher[0]);
          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "application/pdf" });
          fs.saveAs(blob, "carhire_" + this.item.referenceno + ".pdf");
        }

        sent = response.data.carhire_voucher.length > 0 ? true : false;


      } catch (error) {
        console.log(error);
      }
      if (sent) {
        this.message =
          "<span class='text-primary'>Car vouchers will be emailed to you by SL A/C</span>";
      } else {
        this.message = "<span class='text-danger'>Email not sent!</span>";
      }

      this.busy = false;
    },

    async saveit() {
      this.busy = true;

      let rows = [this.cleanit(this.item)];

       let requirements = "";
      for (var prop in this.requirement) {
        if (prop.slice(0, 3) != 'mi_') {
          if (rows[0][prop] == null) {
            requirements += this.requirement[prop] + ",";
            break;
          }
        }
      }
      requirements += await this.mifields_requirement()

      console.log("requirements", requirements);
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message = ""
      }


     // let requirements = await this.mifields_requirement()
     // if (requirements.length > 0) {
     //   this.message =
     //     "<span class='text-danger'>" +
      //    requirements.slice(0, -1) +
     //     " required field(s). </span>";
     //   this.busy = false;
     //   return;
     // } else {
     //   this.message = ""
     // }


      rows[0].start_at = this.start_at.startDate
      rows[0].end_at = this.end_at.startDate
      if (!rows[0].agent) {
        rows[0].agent = this.user.initials;
      }

      if (this.mifields.length > 0) {
        let tags = JSON.parse(this.item.tags || "{}");
        for (var k = 0; k < this.mifields.length; k++) {
          tags[this.mifields[k].key] = this.mifields[k].value;
        }
        rows[0].tags = JSON.stringify(tags);
      }

      let variables = {
        rows,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation carhire_save($rows: [InventoryLine_input]) {
              carhire_save(rows: $rows) {
                id
                    type
                    issued_at
                    referenceno
                    invoicetype                                       
                    yourref
                    start_at
                    blac  
                    reference
                    cost                    
                    markup
                    sale  
                    quoted                                     
                    slac
                    eventcode             
                    agent
                    status
                    invoiceno    
                    blinvoiceno
                    cost
                    sale
                    # booker                    
                    startcity
                    end_at
                    endcity
                    startlocation
                    endlocation
                    cabin
                    equipment
                    reference
                    pax
                    passenger
                    surname
                    firstname
                    title
                    description
                    data
                    notes
                    equipmentname
                    blacname
                    blaclogo
                    slacname
                    agentemail
                    created_at
                    created_by
                    updated_at
                    updated_by
                    rows
              }
            }
          `,
          variables,
        });

        if (response.data.carhire_save.length > 0) {
          this.item = response.data.carhire_save[0];

          if (this.item.start_at) {
            let v = this.$moment.unix(this.item.start_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
            this.start_at = { startDate: v, endDate: v }
          }
          if (this.item.end_at) {
            let v = this.$moment.unix(this.item.end_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
            this.end_at = { startDate: v, endDate: v }
          }
        }
        this.message = "<span class='text-primary'>Saved it.</span>";

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },

    async ihold_load(offset, limit, page) {

      let state = this.ihold;

      state.busy = true;

      let variables = {
        id: this.item.id,
        account_id: "CA0771AF-73F3-4972-B9B8-78BAAAA3C7DF"
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
        query ihold(
          $id: String
          $account_id: String
        ) {
          ihold(
            id: $id
            account_id: $account_id
          ) {
            id
            referenceno
            eventcode
            eventname
            slac
            slacname
            yourref
            cost
            sale
            vat
            total
            invoiceno
            posted
            agent
            lines {
              id
              type
              referenceno
              routing
              remark 
              equipment
              start_at
              end_at
              details
              description
              passenger
              qty
              sale
              vat
              vatrate
              markup
              total                
              cost
              blac
              payby
              costcurrency
              margin
              agent
              notes
              expanded
            }
            data
            rows
          }
        }
      `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.ihold

        } else {
          state.items = []
          state.items = response.data.ihold;
        }

      } catch (error) {
        console.log(error);
      }
      state.busy = false;
    },

    async ihold_click(a, ss) {
      console.log("ihold_click", a, ss);
      switch (a) {
        case "filter":
          this.ihold.filter = !this.ihold.filter;
          break;
        case "back":
          this.discard();
          break;
        case "save":
          this.saveit();
          break;
        case "posted":
          this.postit(ss);
          break;
        case "go":
          break;
      }
    },
    async ihold_select(ss, tools) {
      console.log("ihold_click", ss);

      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "autoquery", "filter", "export"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });

        tool = tools.find((o) => o.action == "deleteconfirm");
        if (tool) {
          tool.disabled = ss.length > 0 ? false : true;
        }
        tool = tools.find((o) => o.action == "notes");
        if (tool) {
          tool.disabled = ss.length == 1 ? false : true;
        }
      }

      this.ihold.selected = ss;
    },
    reversenamecap(data, ispassenger) {
      if (data) {
        let result = data.toString().toUpperCase()
        if (result) {
          let parts = result.split(' ')
          if (parts.length > 0) {
            result = parts[parts.length - 1] + "/"
            if (ispassenger) { this.item.surname = parts[parts.length - 1] }
            parts = parts.slice(0, -1)
            if (parts.length > 0) {
              result += parts.join(" ")
              if (ispassenger) { this.item.firstname = parts.join(" ") }
            }
            this.item.title = ""
          }
        }
        return result
      }
    },

  },
};
</script>

<style></style>